import { COLORS } from '@shared/config/colors/colors';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    gap: 36px;
`;

export const FormBox = styled('form')`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    gap: 40px;
`;

export const Controls = styled('div')`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 20px;
`;

export const Divider = styled('div')`
    width: 100%;
    border-bottom: 1px solid ${COLORS.neutral_20};
`;

export const FooterText = styled('div')`
    display: flex;
    width: 100%;
    gap: 12px;
`;
